<div class="mt-56px">
    <div class="custella-form-container left-right-space rounded-2">
        <div class="custella-form-container-title" id="title_InvConsignDet" *ngIf="parentType == 'requisition'">{{translate?.requisition.sections.sec10.singular}}</div>
        <div class="custella-form-container-title" id="title_InvConsignDet"  *ngIf="parentType == 'consignment'">{{translate?.consignment.sections.sec7.singular}}</div>
        
       
         <!---------------- ASSET -------------------------------------------------------------------------------------------->
         <div class="custella-form-container-content" *ngIf="requestType === 'asset'">
            <h5 class="font-medium text-center" *ngIf="parentType == 'requisition'">{{translate?.requisition.messages.whatWouldYouLikeRequest}}</h5>
            <h5 class="font-medium text-center" *ngIf="parentType == 'consignment'">{{translate?.consignment.messages.whatWouldYouLikeSend}}</h5>
            <div class="form-options-two mt-4" >
                <!-- Requisition -->
                <div class="items-sm"  *ngIf="parentType == 'requisition'"  (click)="onSelectOptionTypeChange('specificAssets')">
                    <h6><i class="fa-regular fa-truck fa-xl"></i>{{translate?.requisition.messages.specificAssets}}</h6>
                    <span class="desc">
                        <span class="text-center">{{translate?.requisition.messages.chooseThisSerialNumber}}</span>
                    </span>
                </div>
                <div class="items-sm" *ngIf="parentType == 'requisition'" (click)="onSelectOptionTypeChange('assetType')">
                    <h6><i class="fa-regular fa-box-check fa-xl"></i>{{translate?.requisition.messages.requestByType}}</h6>  
                    <span class="desc">
                        <span class="text-center">{{translate?.requisition.messages.requestAssetByTypeQty}}</span>
                    </span>
                </div>
                <!-- Consignment -->
                <div class="items-sm" *ngIf="parentType == 'consignment'" (click)="onSelectOptionTypeChange('specificAssets')">
                    <h6><i class="fa-regular fa-truck fa-xl"></i>{{translate?.consignment.messages.specificAssets}}</h6>
                    <span class="desc">
                        <span class="text-center" >{{translate?.consignment.messages.chooseThisSerialNumber}}</span>
                    </span>
                </div>
                <div class="items-sm" *ngIf="parentType == 'consignment'" (click)="onSelectOptionTypeChange('assetType')">
                    <h6><i class="fa-regular fa-box-check fa-xl"></i>{{translate?.consignment.messages.sendByType}}</h6>  
                    <span class="desc">
                        <span class="text-center">{{translate?.consignment.messages.sendAssetByTypeQty}}</span>
                    </span>
                </div>
            </div>
        </div>

        <!------------------------------------- SPARE PARTS ------------------------------------------------------------------->
        <div class="custella-form-container-content"  *ngIf="requestType === 'sparePart'">
            <h5 class="font-medium text-center" *ngIf="parentType == 'requisition'">{{translate?.requisition.messages.whatWouldYouLikeRequest}}</h5>
            <h5 class="font-medium text-center" *ngIf="parentType == 'consignment'">{{translate?.consignment.messages.whatWouldYouLikeSend}}</h5>
            <div class="form-options-two mt-4" (click)="requestType = 'asset'">
                <!-- Requisition -->
                <div class="items-sm" *ngIf="parentType == 'requisition'" (click)="onSelectOptionTypeChange('selectFromBin')" >
                    <h6><i class="fa-regular fa-truck fa-xl"></i>{{translate?.requisition.messages.requestFromBin}}</h6>
                    <span class="desc">
                        <span class="text-center">{{translate?.requisition.messages.selectSparePartFromBin}}</span>
                    </span>
                </div>
                <div class="items-sm" *ngIf="parentType == 'requisition'" (click)="onSelectOptionTypeChange('requestFromBin')" >
                    <h6><i class="fa-regular fa-box-check fa-xl"></i>{{translate?.requisition.messages.requestAnyAvailable}}</h6>  
                    <span class="desc">
                        <span class="text-center">{{translate?.requisition.messages.requestSparePartFromBin}}</span>
                    </span>
                </div>

                <!-- Consignment -->
                <div class="items-sm" *ngIf="parentType == 'consignment'" (click)="onSelectOptionTypeChange('selectFromBin')" >
                    <h6><i class="fa-regular fa-box fa-xl"></i>{{translate?.consignment.messages.sendFromBin}}</h6>
                    <span class="desc">
                        <span class="text-center">{{translate?.consignment.messages.selectSparePartFromBin}}</span>
                    </span>
                </div>
                <div class="items-sm" *ngIf="parentType == 'consignment'" (click)="onSelectOptionTypeChange('requestFromBin')"  >
                    <h6><i class="fa-regular fa-gears fa-xl"></i>{{translate?.consignment.messages.sendAnyAvailable}}</h6>  
                    <span class="desc">
                        <span class="text-center">{{translate?.consignment.messages.sendSparePartAvailableFromBin}}</span>
                    </span>
                </div>
            </div>
        </div>

        
        <div class="custella-form-container-footer">
            <div class="d-flex align-items-center justify-content-end">
                <button class="custella-btn-white text-12 ms-2" (click)="cancel()">{{translate?.general.buttons.cancel.singular}}</button>
                <p-button  [label]="translate?.general.buttons.back.singular" styleClass="ms-2 h-32" (onClick)="goBack()"></p-button>
               </div>
        </div>
    </div>
</div>